import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Select } from "./ui/select";
import { supportedUiLocales, type SupportedLocale } from "../lib/preferences";

type LanguageMenuProps = {
  value: SupportedLocale;
  onChange: (locale: SupportedLocale) => void;
};

export function LanguageMenu({ value, onChange }: LanguageMenuProps) {
  const { t } = useTranslation("common");

  return (
    <div className="inline-control">
      <Languages aria-hidden="true" size={17} />
      <Select
        aria-label={t("language.label")}
        data-testid="language-select"
        label={t("language.short")}
        onChange={(event) => onChange(event.target.value as SupportedLocale)}
        value={value}
      >
        {supportedUiLocales.map((locale) => (
          <option key={locale} value={locale}>
            {t(`language.options.${locale}`)}
          </option>
        ))}
      </Select>
    </div>
  );
}
